// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_centered-col__Qjw4w {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center; }

.styles_hide-scrollbar__No8Nr {
  -ms-overflow-style: none;
  scrollbar-width: none; }
  .styles_hide-scrollbar__No8Nr::-webkit-scrollbar {
    display: none; }

.styles_singleLineText__D4cBK {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis; }

.styles_width-fill-available__TTnqI {
  width: 100%;
  /* WebKit-based browsers will ignore this. */
  width: -webkit-fill-available;
  /* Mozilla-based browsers will ignore this. */
  width: fill-available; }

.styles_height-fill-available__C0kkF, .styles_internalContainer__ZMK1L {
  height: 100%;
  /* WebKit-based browsers will ignore this. */
  height: -webkit-fill-available;
  /* Mozilla-based browsers will ignore this. */
  height: fill-available; }

.styles_internalContainer__ZMK1L {
  min-height: 10rem;
  padding: 0.5rem 1rem;
  overflow-y: scroll; }
  .styles_internalContainer__ZMK1L p {
    white-space: inherit; }

.styles_open__WQtPm .styles_cardButton__fIFfU {
  display: none; }
`, "",{"version":3,"sources":["webpack://./src/modules/Core/styles/classes.scss","webpack://./src/modules/Core/components/Feed/ExpandableFeedItem/styles.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB,EAAA;;AAGrB;EACE,wBAAwB;EACxB,qBAAqB,EAAA;EAFvB;IAII,aAAa,EAAA;;AAIjB;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB,EAAA;;AAGzB;EACE,WAAW;EACY,4CAAA;EACvB,6BAA6B;EAAE,6CAAA;EAC/B,qBAAqB,EAAA;;AAGvB;EACE,YAAY;EACY,4CAAA;EACxB,8BAA8B;EAAE,6CAAA;EAChC,sBAAsB,EAAA;;AC9BxB;EACI,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB,EAAA;EAHtB;IAOS,oBAAoB,EAAA;;AAI7B;EAEQ,aAAa,EAAA","sourcesContent":[".centered-col {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.hide-scrollbar {\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n  &::-webkit-scrollbar {\n    display: none;\n  }\n}\n\n.singleLineText {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.width-fill-available {\n  width: 100%;\n  width: -moz-available; /* WebKit-based browsers will ignore this. */\n  width: -webkit-fill-available; /* Mozilla-based browsers will ignore this. */\n  width: fill-available;\n}\n\n.height-fill-available {\n  height: 100%;\n  height: -moz-available; /* WebKit-based browsers will ignore this. */\n  height: -webkit-fill-available; /* Mozilla-based browsers will ignore this. */\n  height: fill-available;\n}\n","@import \"src/modules/Core/styles/classes.scss\";\n\n.internalContainer {\n    min-height: 10rem;\n    padding: 0.5rem 1rem;\n    overflow-y: scroll;\n    @extend .height-fill-available;\n    \n     & p {\n         white-space: inherit;\n     }\n}\n\n.open {\n    .cardButton {\n        display: none;\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"centered-col": `styles_centered-col__Qjw4w`,
	"hide-scrollbar": `styles_hide-scrollbar__No8Nr`,
	"singleLineText": `styles_singleLineText__D4cBK`,
	"width-fill-available": `styles_width-fill-available__TTnqI`,
	"height-fill-available": `styles_height-fill-available__C0kkF`,
	"internalContainer": `styles_internalContainer__ZMK1L`,
	"open": `styles_open__WQtPm`,
	"cardButton": `styles_cardButton__fIFfU`
};
export default ___CSS_LOADER_EXPORT___;
